import styled from '@emotion/styled';

import { ButtonVariant } from './Button';

export const Button = styled.button<{ buttonStyle: ButtonVariant; hasIcon: boolean }>`
  text-align: center;
  font-weight: 700;
  background-color: ${({ buttonStyle }) =>
    buttonStyle === 'primary'
      ? 'var(--button-primary-background)'
      : buttonStyle === 'secondary'
      ? 'var(--button-secondary-background)'
      : '#fff'};
  border: ${({ buttonStyle }) =>
    (['primary', 'secondary'] as ButtonVariant[]).includes(buttonStyle)
      ? 'solid 2px var(--button-primary-background)'
      : 'none'};
  border-radius: var(--button-border-radius);
  color: ${({ buttonStyle }) => (buttonStyle === 'primary' ? 'var(--button-primary-color)' : '#005CB9')};
  cursor: pointer;
  padding: ${({ buttonStyle, hasIcon }) =>
    buttonStyle === 'discrete'
      ? '0'
      : hasIcon
      ? '13px var(--whitespace-widest)'
      : 'var(--whitespace-medium) var(--whitespace-widest)'};

  &:hover {
    background-color: ${({ buttonStyle }) =>
      buttonStyle === 'primary'
        ? 'var(--button-primary-background-hover)'
        : buttonStyle === 'secondary'
        ? 'var(--button-secondary-background-hover)'
        : '#fff'};
  }
`;

export const Inner = styled.div`
  display: flex;
  gap: 8px;
  justify-items: center;
  align-items: center;
`;
